// Plugins
import { registerPlugins } from '@/plugins';
// Components
import App from '@/App.vue';
// Composables
import '@/styles/materialdesignicons-local.css';
import '@/styles/roboto-local.css';
import { createApp, type App as VueApp } from 'vue';

// Create Vue application instance
const app: VueApp = createApp(App);

app.config.errorHandler = (err, instance, info) => {
  console.error('Global error handler:', err, 'Error info:', info);
};

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  event.preventDefault();
});

// Register plugins with error handling
try {
  registerPlugins(app);
} catch (error) {
  console.error('Failed to register plugins:', error);
  throw error; // Re-throw to prevent app from starting with missing plugins
}

// Mount application with element check
const mountElement = document.querySelector('#app');
if (!mountElement) {
  throw new Error('Failed to find #app element');
}

app.mount(mountElement);
